import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { getInt } from 'utils/functions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { loadPartnerFileHeader } from 'features/partnerFile/actionCreators';
import { getPartnerFileHeader } from 'features/partnerFile/selectors';
import PartnerFileWizard from './PartnerFileWizard';

const PartnerFileWizardRouteContainer = ({ match, history, location }) => {
  const dispatch = useDispatch();
  const documentId = getInt(match.params.documentId);
  const siteId = getInt(match.params.siteId);
  const isNewPartnerFile = match.params.newPartnerFile === 'new';
  const isNewBulkFile = match.params.newBulkFile === 'new-bulk';

  const { loaded, content } = useSelector(state => getPartnerFileHeader(state, documentId, siteId), shallowEqual);

  useEffect(() => {
    if (content.loaded || content.loading || isNewPartnerFile || isNewBulkFile) return;
    dispatch(loadPartnerFileHeader(documentId, siteId));
  }, [documentId, siteId, loaded, content.loaded, content.loading, isNewPartnerFile, isNewBulkFile, dispatch]);

  return (
    (isNewPartnerFile || isNewBulkFile || loaded) && (
      <PartnerFileWizard
        documentId={documentId}
        siteId={siteId}
        isNewPartnerFile={isNewPartnerFile}
        isNewBulkFile={isNewBulkFile}
        partnerFileHeader={content}
        history={history}
        locationPathName={location.pathname}
      />
    )
  );
};

PartnerFileWizardRouteContainer.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object,
  history: PropTypes.object.isRequired
};

export default withRouter(PartnerFileWizardRouteContainer);
